<template>
  <div id="modal">
    <button class="closey iconclose" @click="onCloseModal" />
    <slot></slot>
  </div>
</template>

<script>
import axios from "axios";
import { memoize } from "@/utils/memoize";

export default {
  name: "Modal",
  props: ["closeModal"],

  methods: {
    onCloseModal() {
      this.$emit("closeModal");
    }
  }
};
</script>

<style>
#modal {
  position: absolute;
  bottom: 2calc (25% - 24px);
  top: calc(25% - 24px);
  left: calc(25% - 24px);
  right: calc(25% - 24px);
  width: calc(50% - 24px);
  z-index: 11000;
  height: auto;
  background: rgba(255, 255, 255, 0.9);
  padding: 12px;
  border: 2px solid #c53526;
  padding: 2 4px;
}

@media screen and (min-width: 320px) and (max-width: 850px) {
  #modal {
    top: 0;
    left: 0;
    right: 0;
    width: calc(100% - 32px);
  }
  #modal #map {
    height: 75vh;
  }
}
</style>
